import CatalogSettings from 'pages/SettingsPage/General/CatalogSettings/CatalogSettings';

export default CatalogSettings;
